import Divider from "antd/lib/divider";
import clsx from "clsx";
import Link from "next/link";
import React from "react";
import { useTranslation } from "react-i18next";

import { interpolate, Route } from "@sol/routing";
import { getResourceUuid, IClassroomItem } from "@sol/sdk";
import { ArrowRight } from "@sol/uikit/core/icons/Arrows/ArrowRight";
import { Button } from "@sol/uikit/general/Button/Button";

import { ClassroomProgression, ClassroomRepartition, ClassroomWorkProgress } from "@/features/dashboards";

type ClassroomSlideProps = {
    classroom: IClassroomItem;
    className?: string;
};

export function ClassroomSlide({ classroom, className }: ClassroomSlideProps) {
    const [t] = useTranslation();

    return (
        <div className={clsx("size-full", className)}>
            <div className="flex size-full flex-col p-ant-sm select-none">
                <h2 className="mb-ant-xxs! truncate font-ant text-ant-h3 leading-ant-h3 font-ant-strong text-color-ant-primary!">
                    {classroom.title}
                </h2>

                <ClassroomProgression classroom={classroom} size="default" />

                <Divider />

                <ClassroomRepartition classroom={classroom} />

                <Divider />

                <ClassroomWorkProgress classroom={classroom} />

                <div className="my-ant-lg text-center">
                    <Link
                        href={interpolate(Route.CLASSROOMS_STATISTICS, {
                            classroomId: getResourceUuid(classroom),
                        })}
                        passHref
                    >
                        <Button
                            className="truncate"
                            size="small"
                            iconPosition="end"
                            icon={<ArrowRight variant="antd" />}
                            title={t("page.home.trainers.classroomsCard.item.cta.a11y", {
                                classroomName: classroom.title,
                            })}
                            aria-label={t("page.home.trainers.classroomsCard.item.cta.a11y", {
                                classroomName: classroom.title,
                            })}
                        >
                            {t("page.home.trainers.classroomsCard.item.cta.titleProgression")}
                        </Button>
                    </Link>
                </div>
            </div>
        </div>
    );
}
